<template>
  <div v-if="dropdownItems.length != 0" class="relative top-0 w-full h-6 mt-6 bg-window-white flex justify-between">
    <div class="w-full h-full px-0.5 pt-0.5 pb-px flex items-center border-window-header-right border-window-header-bot">
      <WindowDropdown v-for="(item, index) in dropdownItems" :key="index">
        <template #text>
          {{ item }}
        </template>
      </WindowDropdown>
      <button
        v-if="windowId === 'notepad'"
        @click="handleSave"
        class="h-full small-p hover:bg-dropdown hover:text-white px-1.5 flex items-center cursor-pointer ml-1"
      >
        Save
      </button>
    </div>
    <div v-if="windowsHeaderLogo" class="flex items-center h-6 w-10">
      <img src="/img/icons/windows-header-window-icon.webp" :alt="$t('common.icon') + ' windows'" class="h-full pt-0.5 border-window-header-bot" />
    </div>
  </div>
</template>

<script setup>
import WindowDropdown from '@/components/Buttons/WindowDropdown.vue'

const props = defineProps({
  dropdownItems: {
    type: Array,
    default: () => []
  },
  windowsHeaderLogo: {
    type: Boolean,
    default: true
  },
  windowId: {
    type: String,
    default: ''
  }
})

const handleSave = () => {
  // Dispatch a custom event that the Notepad component will listen to
  window.dispatchEvent(new CustomEvent('notepad-save'))
}
</script>
